module.exports = __webpack_public_path__ + "src/assets/img/trank_open.2590c0cf.svg";